import {ApiException} from "@/domain/core/exception/exceptions";
import {emptyListResponse} from "@/domain/core/utils/django";

const state = {
    chargebackTypes: {...emptyListResponse},
    chargebackType: null,
}

export const getters = {
    chargebackTypes: state => state.chargebackTypes,
    chargebackType: state => state.chargebackType,
}

export const mutations = {
    chargebackTypes(state, chargebackTypes) {
        state.chargebackTypes = chargebackTypes
    },
    chargebackType(state, chargebackType) {
        state.chargebackType = chargebackType
    },
    deleteChargebackType(state, id) {
        state.chargebackTypes.results = state.chargebackTypes.results.filter(rt => rt.id !== id)
    },
}

export const actions = service => ({
    async fetchChargebackTypeList({commit}, {filters, pagination, sorting}) {
        try {
            const chargebackTypes = await service.fetchList(filters, pagination, sorting)
            commit('chargebackTypes', chargebackTypes)
        } catch (e) {
            if (e instanceof ApiException) {
                commit('chargebackTypes', emptyListResponse)
            }
            throw e
        }
    },
    async fetchChargebackType({commit}, id) {
        const chargebackType = await service.fetchDetail(id)
        commit('chargebackType', chargebackType)
    },
    async createChargebackType({commit}, data) {
        const chargebackType = await service.createChargebackType(data)
        commit('chargebackType', chargebackType)
    },
    async updateChargebackType({commit}, {id, data}) {
        const chargebackType = await service.updateChargebackType(id, data)
        commit('chargebackType', chargebackType)
    },
    async deleteChargebackType({commit}, id) {
        await service.deleteChargebackType(id)
        commit('deleteChargebackType', id)
    },
})

export default service => ({
    namespaced: true,
    state,
    getters,
    mutations,
    actions: actions(service)
})
